import React from 'react';
import { Tag } from '@fourthwall/components';
import { STATUSES } from './consts';
const PromotionStatusTagComponent = ({ promotion, size }) => (React.createElement(Tag, { label: STATUSES[promotion.status.type]?.label, appearance: STATUSES[promotion.status.type]?.appearance, size: size }));
export const PromotionStatusTag = React.memo(PromotionStatusTagComponent);
